<template>
  <section :class="`lead-table ${theme.isDark ? 'lead-table_dark' : null}`">
    <b-table
      backend-filtering
      :data="leads"
      :loading="loadingLeads"
      :columns="columns"
      :total="totalCount"
      :backend-pagination="true"
      :paginated="isPaginated"
      :per-page="perPage"
      @filters-change="filterTable"
      :current-page.sync="numberPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      :row-class="rowClassHandler"
      @click="handleClick"
      checkable
      :checkbox-position="checkboxPosition"
      :checked-rows.sync="selectedPoolAction"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="pageChangeHandler"
    >
      <template slot="bottom-left">
        <b>Total checked</b>: {{ checkedRows.length }}
      </template>
    </b-table>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "LeadTable",
  inject: ["theme"],
  props: {
    type: String,
    source: String,
  },
  data() {
    return {
      currentSearch: null,
      checkboxPosition: "left",
      checkedRows: [],
      columns: [
        {
          field: "status_title",
          label: "Status",
          searchable: false,
          sortable: true,
        },
        {
          field: "source_title",
          label: "Source",
          searchable: false,
          sortable: true,
        },
        {
          field: "agent_fullname",
          label: "Agent",
          searchable: true,
          sortable: true,
        },
        {
          field: "fullname",
          label: "Full Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "email",
          label: "Email",
          searchable: true,
          sortable: true,
        },
        {
          field: "phone",
          label: "Phone",
          searchable: true,
          sortable: true,
        },
        {
          field: "premium_price",
          label: "Premium",
          searchable: true,
          width: 120,
        },
        {
          field: "premium_carrier",
          label: "Carrier",
          searchable: true,
          sortable: true,
        },
        {
          field: "term",
          label: "Product",
          searchable: true,
          sortable: true,
          width: 50,
        },
        {
          field: "state",
          label: "State",
          searchable: false,
          sortable: true,
          width: 50,
        },
        {
          field: "updated",
          label: "Last Change",
          searchable: true,
          sortable: true,
        },
      ],
      columnsHealth: [
        {
          field: "status_title",
          label: "Status",
          searchable: true,
          sortable: true,
        },
        {
          field: "source_title",
          label: "Source",
          searchable: true,
          sortable: true,
        },
        {
          field: "agent_fullname",
          label: "Agent",
          searchable: true,
          sortable: true,
        },
        {
          field: "fullname",
          label: "Full Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "email",
          label: "Email",
          searchable: true,
          sortable: true,
        },
        {
          field: "phone",
          label: "Phone",
          searchable: true,
          sortable: true,
        },
        {
          field: "coverage_type",
          label: "Product",
          searchable: true,
          sortable: true,
          width: 50,
        },
        {
          field: "state",
          label: "State",
          searchable: true,
          sortable: true,
          width: 50,
        },
        {
          field: "updated",
          label: "Last Change",
          searchable: true,
          sortable: true,
        },
      ],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      perPage: 10,
    };
  },
  methods: {
    ...mapMutations({
      SET_CURRENT_PAGE: "leads/SET_CURRENT_PAGE",
      SET_SELECTED_POOL: "leads/SET_SELECTED_POOL",
    }),
    ...mapActions({
      loadLeadsByFilters: "leads/loadLeadsByFilters",
      loadLeadsBySearch: "leads/loadLeadsBySearch",
    }),

    handleClick(payload) {
      event.preventDefault();
      if (!payload.busy) {
        this.$router.push({ path: `/lead/${payload.id}` });
      }
    },

    rowClassHandler(row) {
      if (row.type_id == 2) {
        if (row.status == "in-force") return "is-blue";
        if (row.status == "approved") return "is-blue";
        if (row.status == "aota") return "is-blue";
        if (row.status == "condIssued") return "is-blue";
        if (row.status == "declined") return "is-blue";
        if (row.status == "cancelled") return "is-blue";
      }
      if (row.busy) return "is-busy";
      if (row.status == "priceTooHigh") return "is-pink";
      if (row.status == "notInterested") return "is-red";
      if (row.status == "doNotCall") return "is-red";
      if (row.status == "wrongPhoneNumber") return "is-red";
      if (row.status == "followUp") return "is-green";
      if (row.status == "thinkingAboutIt") return "is-orange";
      if (row.status == "inApplication") return "is-blue";
      if (row.status == "purchased") return "is-blue";
      if (row.status == "declined") return "is-red";
      if (row.status == "underwriting") return "is-blue";
    },
    pageChangeHandler(pageNumber) {
      this.loadLeadsByFilters({ params: this.leadFilters, search: this.currentSearch, page: pageNumber});
    },
    filterTable(search) {
      this.currentSearch = search;
      this.loadLeadsBySearch({ filterParams: this.leadFilters, searchParams: search });
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      leads: "leads/leads",
      selectedPool: "leads/selectedPool",
      loadingLeads: "leads/loadingLeads",
      currentPage: "leads/currentPage",
      leadFilters: "filters/leadFilters",
      totalCount: "leads/totalCount",
    }),
    numberPage: {
      get: function () {
        return this.currentPage;
      },
      set: function () {},
    },
    selectedPoolAction: {
      get: function () {
        return this.selectedPool;
      },
      set: function (leads) {
        this.SET_SELECTED_POOL(leads);
      },
    },
  },
  mounted() {
    switch (this.leadFilters.type) {
      case 4:
        this.columns = this.columnsHealth;
    }
  },
};
</script>


<style lang="scss">
$loading-background-legacy: #7f7f7f !default;
$loading-background: rgba(255, 255, 255, 0.5) !default;
$loading-icon-size: 3em !default;
$loading-full-page-icon-size: 5em !default;

.loading-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 999;
  &.is-active {
    display: flex;
  }
  &.is-full-page {
    position: fixed;
    .loading-icon {
      &:after {
        top: calc(50% - #{$loading-full-page-icon-size / 2});
        left: calc(50% - #{$loading-full-page-icon-size / 2});
        width: $loading-full-page-icon-size;
        height: $loading-full-page-icon-size;
      }
    }
  }
  .loading-background {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    background: $loading-background-legacy;
    background: $loading-background;
  }
  .loading-icon {
    position: relative;
    &:after {
      animation: spinAround 0.5s infinite linear;
      border: 2px solid #dbdbdb;
      border-radius: 9999px;
      border-right-color: transparent;
      border-top-color: transparent;
      content: "";
      display: block;
      height: 1em;
      position: relative;
      width: 1em;
      position: absolute;
      top: calc(50% - #{$loading-icon-size / 2});
      left: calc(50% - #{$loading-icon-size / 2});
      width: $loading-icon-size;
      height: $loading-icon-size;
      border-width: 0.25em;
    }
  }
}

@keyframes spinAround {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>